<!-- 2025.4.17厦门国际银行结构性存款中转页（微信环境提示用户在浏览器打开） -->
<template>
  <div class="">
    <div v-if="!isWeixn" @click="download" class="download-btn">
      如未安装手机银行，请<span style="text-decoration: underline"
        >点击下载</span
      >
    </div>
    <van-popup
      v-model:show="isWeixn"
      position="top"
      :close-on-click-overlay="false"
      class="open-browser-popup"
    >
      <img
        class="share-tip"
        :src="require(`@/assets/imgs/xiamenBank/share-tip.png`)"
        alt=""
      />
    </van-popup>
    <div class="xiame-bank-deposit-standard-share" @click="toFastOpen">
      <img
        class="img"
        :src="require(`@/assets/imgs/xiamenBank/structuredDeposits1.jpg`)"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: '厦门国际银行',
      isWeixn: false,
    }
  },
  mounted() {
    document.title = this.title;
  },
  created() {
    this.isWeixn = this.isWeixnFun()
    this.toFastOpen()
  },
  methods: {
    // 唤醒个人手机银行app
    toFastOpen() {
      if (this.isWeixn) return
      // 跳转app页面
      // let appPage = process.env.VUE_APP_XIAMENBANK_DEPOSITS_TRANSFERPAGE
      let appPage = 'https://mobile.xib.com.cn/v4-std/deposit/index.html#/structural-deposit/detail?productCode=GRHLA2025648&xiblogin=true'

      //  当前分享页面
      let sharePage = window.location.href
      let openUrl = `xib://mobile.xib.com.cn?type=vue&url=${encodeURIComponent(appPage)}`
      let weUrl = `https://ifsp.xib.com.cn/ifspopenapi/thirdParty/auth/redirect?client_id=xib_ydsh&scope=m&xiblogin=true&redirect_uri=${encodeURIComponent(sharePage)}` //当前分享页面链接

      console.log(openUrl);
      window.openApp(openUrl, weUrl, 'false')
    },
    download() {
      window.loadAPPClick()
    },
    isWeixnFun() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },

  }
}
</script>

<style lang="less" scoped >
.download-btn {
  background: #fff;
  width: 100%;
  line-height: 2;
  text-align: center;
}

/deep/ .open-browser-popup {
  background: none;
  text-align: right;
  padding: 53px 28px 0 0;

  .share-tip {
    width: 265px;
  }
}

.xiame-bank-deposit-standard-share {
  .img {
    width: 100%;
    height: auto;
  }
}
</style>
